'use client';

import { FC, useState } from 'react';
import { Rating } from 'atoms/Rating';
import { Tooltip } from 'molecules/Tooltip';
import { RatingInfo } from './RatingInfo';
import { RatingWithTooltipProps } from './types';

export const RatingWithTooltip: FC<RatingWithTooltipProps> = ({
  count,
  value,
  ranks,
  url,
  size,
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleTooltip = () => {
    setIsOpen((isOpen) => !isOpen);
  };

  return (
    <Tooltip
      onClose={toggleTooltip}
      open={isOpen}
      element={<RatingInfo count={count} ranks={ranks} url={url} />}
    >
      <Rating
        value={value}
        size={size}
        className={className}
        onClick={toggleTooltip}
      />
    </Tooltip>
  );
};
